// Maps a CustomAttributeDefinition display type to a form-builder field_type.
// Single source of truth shared by FieldPalette.vue and workflowFieldsToFormFields.js.
export const DISPLAY_TYPE_TO_FIELD_TYPE = {
  text: 'text',
  number: 'number',
  currency: 'number',
  percent: 'number',
  link: 'text',
  date: 'date',
  list: 'select',
  checkbox: 'checkbox',
};

export function fieldTypeForDisplayType(displayType) {
  return DISPLAY_TYPE_TO_FIELD_TYPE[displayType] || 'text';
}
